import React, {
  forwardRef,
  useContext,
  useImperativeHandle,
  useState,
  useEffect,
    useRef,
} from "react";
import { getServiceDetails } from "../API/LinkedServicesApi";
import AuthContext from "../Context/AuthProvider";
import ConfirmationDialog from "../common/ConfirmationDialog";
import SendIcon from "@mui/icons-material/Send";
import { sendDocumentToPatient } from "../API/PatientCommunicationApi";
import Drawing from "./Drawing";
import { getDiagrams, deleteDiagram } from "../API/DiagramApi";

import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Fab,
  Grid2,
  IconButton,
  Menu,
  MenuItem,
  Tooltip,
  Typography,
  ListItemIcon,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import {
  AddRounded,
  CloseOutlined,
  CreateOutlined,
  Visibility,
  NoteAdd,
  FileDownload,
  Fullscreen,
  MoreVert,
} from "@mui/icons-material";
import { DataGrid } from "@mui/x-data-grid";
import { Link } from "react-router-dom";
import dayjs from "dayjs";
import {
  getPrescriptionsForService,
  removePrescription,
} from "../API/PrescriptionApi";
import {
  AvailablePrescriptionTypes,
  MedicalRecordTypes,
  NoteTypes,
} from "../Utility/Constants";
import MenuBar from "../common/MenuBar";
import {
  addclinicalNote,
  deleteClinicalNote,
  getClinicalNote,
  getClinicalNotesForService,
} from "../API/ClinicalNoteApi";
import { GridExpandMoreIcon } from "@mui/x-data-grid";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { useSnackbar } from "../Utility/UserMessageContext";
// import { getVisitByFacility } from "../API/VisitsApi";
import LoadingScreen from "../Utility/LoadingScreen";
import { uploadMedicalRecord } from "../API/MedicalRecordApi";
import {
  formatAge,
  getDisplayValue,
  getLabelOfPrescriptionTypes,
} from "../Utility/Utility";
import {
  CardActions,
  Divider,
  Chip,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import {
  iconButtonStyles,
  PrescriptionTypes,
  WorkItemViewModes,
} from "../Utility/Constants";
import {
  getMedicalRecordMetadata,
  downloadMedicalRecord,
} from "../API/MedicalRecordApi";
import { capitalizeFirstLetter } from "../Utility/Utility";
import {
  convertUTCToTimeZone,
  convertUTCToTimeZoneDateString,
  convertUTCToTimeZoneDateTimeString,
} from "../Utility/DateTimeUtility";
import {
  getMyAssignedServices,
  updateServiceStatus,
} from "../API/LinkedServicesApi";
import { ServiceStatus } from "../Utility/Constants";
import { PlayCircleOutline, Undo, Done } from "@mui/icons-material";
import GenericActionButton from "../common/GenericActionButton";

const WorkItemDetails = forwardRef(
  (
    {
      serviceId,
      viewMode = WorkItemViewModes.DEFAULT,
      onViewPrescription,
      onEditPrescription,
      onAddNewPrescription,
      onAddNote,
      onViewNote,
      onAddMedicalRecord,
      onViewPatientDetails,
      onViewVisitDetails,
       onAddTLDraw,
       onOpenSavedTLDraw,
    },
    ref,
  ) => {
    const { showSnackbar } = useSnackbar();
    const { auth } = useContext(AuthContext);
    const [service, setService] = useState({});
    const [prescriptions, setPrescriptions] = useState([]);
    const [clinicalNotes, setClinicalNotes] = useState([]);
    const [medicalRecords, setMedicalRecords] = useState([]);
    const [whiteboards, setWhiteboards] = useState([]);
    const [showAddPrescriptionrMenu, setShowAddPrescriptionrMenu] =
      useState(false);
    const [addPrescriptionMenuAnchor, setAddPrescriptionMenuAnchor] =
      useState(null);
    const [isLoadingNotes, setIsLoadingNotes] = useState(false);
    const [isLoadingMedicalRecords, setIsLoadingMedicalRecords] =
      useState(false);
    const [previewDialogOpen, setPreviewDialogOpen] = useState(false);
    const [selectedRecord, setSelectedRecord] = useState(null);
    const [isLoadingServiceData, setIsLoadingServiceData] = useState(false);
    const [isLoadingPrescriptions, setIsLoadingPrescriptions] = useState(false);
    const [previewLoading, setPreviewLoading] = useState(false);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));
    const [isUpdatingStatus, setIsUpdatingStatus] = useState(false);
    const [openUndoDialog, setOpenUndoDialog] = useState(false);
    const [rowMenuAnchor, setRowMenuAnchor] = useState(null);
    const [selectedRowForMenu, setSelectedRowForMenu] = useState(null);
    const [tempRowIdForDelete, settempRowIdForDelete] = useState();
    const [sendToPatientDialogOpen, setSendToPatientDialogOpen] =
      useState(false);
    const [selectedRowForSend, setSelectedRowForSend] = useState(null);

    const [isSending, setIsSending] = useState(false);
//     const [whiteboardPreviewOpen, setWhiteboardPreviewOpen] = useState(false);
// const [whiteboardPreviewEntry, setWhiteboardPreviewEntry] = useState(null);

    const viewModeConfig = {
      showAddRecord: viewMode !== WorkItemViewModes.FROM_VISIT,
    };

    // console.log("vishal",AvailablePrescriptionTypes.PrescriptionTypes.GeneralPrescription);

    // Update service status
    const updateServiceStatus = async (newStatus) => {
      if (!serviceId) return;

      setIsUpdatingStatus(true);
      try {
        const { updateServiceStatus: updateStatus } =
          await import("../API/LinkedServicesApi");
        const result = await updateStatus(auth, serviceId, newStatus);

        if (result?.isSuccess) {
          const updatedService = await getServiceDetails(auth, serviceId);
          if (updatedService?.isSuccess) {
            setService(updatedService?.data);
            showSnackbar("Service status updated successfully", "success");
          }
        } else {
          showSnackbar(
            result?.data || "Failed to update service status",
            "error",
          );
        }
      } catch (error) {
        console.error("Error updating service status:", error);
        showSnackbar("Error updating service status", "error");
      } finally {
        setIsUpdatingStatus(false);
      }
    };
    const handleSendToPatientClick = (row) => {
      setSelectedRowForSend(row);
      setSendToPatientDialogOpen(true);
      handleRowMenuClose();
    };

    // Purana mock function hata do aur ye rakh do:

    const handleSendToPatient = async (method) => {
      if (!selectedRowForSend) return;

      setIsSending(true);

      try {
        console.log("=== Send to Patient Debug ===");
        console.log("Selected Row:", selectedRowForSend);
        console.log("Document ID:", selectedRowForSend.id);
        console.log("Document Type:", selectedRowForSend.sourceType);
        console.log("Method:", method);

        // IMPORTANT: Backend expects lowercase "email", not "Email"
        const sendingModes = [method === "email" ? "email" : "whatsapp"]; // Changed "Email" to "email"
        console.log("Sending Modes:", sendingModes);

        showSnackbar(`Sending via ${method}...`, "info");

        const result = await sendDocumentToPatient(
          auth,
          selectedRowForSend.id,
          selectedRowForSend.sourceType,
          sendingModes,
        );

        console.log("API Response:", result);
        console.log("Is Success:", result.isSuccess);
        console.log("Response Data:", result.data);

        if (result.isSuccess) {
          showSnackbar(
            `Prescription sent successfully to ${service?.patientEmailId}!`,
            "success",
          );
          setSendToPatientDialogOpen(false);
          setSelectedRowForSend(null);
        } else {
          console.error("API Error:", result.data);
          showSnackbar(result.data || `Failed to send prescription`, "error");
        }
      } catch (error) {
        console.error("Error sending document:", error);
        showSnackbar("Error sending prescription", "error");
      } finally {
        setIsSending(false);
      }
    };

    // Handle undo status
    // const handleUndoServiceStatus = async () => {
    //   let newStatus;
    //   if (service?.status === ServiceStatus.Completed) {
    //     newStatus = ServiceStatus.InProgress;
    //   } else if (service?.status === ServiceStatus.InProgress) {
    //     newStatus = ServiceStatus.NotStarted;
    //   }

    //   if (newStatus) {
    //     await updateServiceStatus(newStatus);
    //   }
    // };
    // Handle undo status - open confirmation dialog
    const handleUndoServiceStatus = () => {
      setOpenUndoDialog(true);
    };

    // Confirm undo status after dialog confirmation
    const confirmUndoStatus = async () => {
      let newStatus;
      if (service?.status === ServiceStatus.Completed) {
        newStatus = ServiceStatus.InProgress;
      } else if (service?.status === ServiceStatus.InProgress) {
        newStatus = ServiceStatus.NotStarted;
      }

      if (newStatus) {
        await updateServiceStatus(newStatus);
      }

      setOpenUndoDialog(false);
    };
    const handleRowMenuOpen = (event, row) => {
      event.stopPropagation();
      setRowMenuAnchor(event.currentTarget);
      setSelectedRowForMenu(row);
    };

    const handleRowMenuClose = () => {
      setRowMenuAnchor(null);
      setSelectedRowForMenu(null);
    };

    const handleViewClick = (row) => {
      if (row.sourceType === "prescription") {
        onViewPrescription(
          row.id,
          row.displayId,
          row.prescriptionType,
          serviceId,
        );
      } else if (row.sourceType === "clinicalnote") {
        onViewNote(service?.id, row);
      } else if (row.sourceType === "medicalRecord") {
        handlePreviewMedicalRecord(row);
      } else if (row.sourceType === "Drawing") {
  onOpenSavedTLDraw && onOpenSavedTLDraw(row.diagramId, row.displayId, serviceId);
}
      handleRowMenuClose();
    };

    const handleEditClick = (row) => {
      if (row.sourceType === "prescription") {
        onEditPrescription(service?.id, row);
      } else if (row.sourceType === "clinicalnote") {
        onViewNote(service?.id, row);
      }
      handleRowMenuClose();
    };

    const handleRemoveClick = (row) => {
      settempRowIdForDelete(row);
      // if (row.sourceType === "prescription") {
      //   onRemovePrescriptionClick(row);
      // } else if (row.sourceType === "clinicalnote") {
      //   onRemoveNoteClick(row);
      // }
      setOpenUndoDialog(true);
      handleRowMenuClose();
    };

    const renderPatientDetailsCard = () => {
      return (
        <Card variant="outlined" sx={{ mb: 2, borderRadius: 2, width: "100%" }}>
          <CardContent sx={{ padding: 2 }}>
            <Typography variant="subtitle1" fontWeight="bold" mb={1}>
              Patient's Details
            </Typography>

            <Divider sx={{ my: 1 }} />

            {/* Patient details section - now takes full width */}
            <Box sx={{ width: "100%" }}>
              <Box sx={{ "& > div": { mb: 1 } }}>
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <Typography variant="body2">Name:</Typography>
                  <Typography variant="body2">
                    <Link to="/patient" state={service?.patientId}>
                      {service?.patientFirstName}&nbsp;
                      {service?.patientLastName}
                    </Link>
                  </Typography>
                </Box>

                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <Typography variant="body2">MRN:</Typography>
                  <Typography variant="body2" align="right">
                    {service.patientMRN || "-"}
                  </Typography>
                </Box>

                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <Typography variant="body2">Age:</Typography>
                  <Typography variant="body2">
                    {formatAge(service.patientAgeInYears)}
                  </Typography>
                </Box>

                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <Typography variant="body2">Gender:</Typography>
                  <Typography variant="body2">
                    {service.patientGender || "-"}
                  </Typography>
                </Box>

                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <Typography variant="body2">Mobile:</Typography>
                  <Typography
                    variant="body2"
                    sx={{ overflowWrap: "break-word" }}
                  >
                    {service.patientMobileNo || "-"}
                  </Typography>
                </Box>

                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <Typography variant="body2">Email:</Typography>
                  <Typography
                    variant="body2"
                    sx={{ overflowWrap: "break-word" }}
                    align="right"
                  >
                    {service.patientEmailId || "-"}
                  </Typography>
                </Box>
              </Box>
            </Box>

            {/* Photo section - moved below the details */}
            <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
              <img
                src={
                  service?.patient?.photo
                    ? service?.patient?.photo
                    : service?.patient?.gender === "Male"
                      ? "./placeholder-image-male-gender.webp"
                      : "./placeholder-image-female-gender.webp"
                }
                className="border rounded p-0"
                alt="PatientPhoto"
                width="80"
                height="80"
              />
            </Box>
          </CardContent>
        </Card>
      );
    };

    // Render visit details card for mobile view
    const renderVisitDetailsCard = () => {
      return (
        <Card variant="outlined" sx={{ mb: 2, borderRadius: 2, width: "100%" }}>
          <CardContent sx={{ padding: 2 }}>
            <Typography variant="subtitle1" fontWeight="bold" mb={1}>
              Visit Details
            </Typography>

            <Divider sx={{ my: 1 }} />

            <Box sx={{ "& > div": { mb: 1 } }}>
              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <Typography variant="body2">Status:</Typography>
                <Typography variant="body2">
                  {getDisplayValue(service?.status)}
                </Typography>
              </Box>

              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <Typography variant="body2">Referred By:</Typography>
                <Typography variant="body2">{service?.referredBy}</Typography>
              </Box>

              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <Typography variant="body2" sx={{ width: 150 }}>
                  Scheduled At:
                </Typography>
                <Typography variant="body2" align="right">
                  {convertUTCToTimeZoneDateTimeString(
                    service?.scheduledStartDateTime,
                    auth?.slectedFacility?.timeZone,
                  )}
                </Typography>
              </Box>

              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <Typography variant="body2">Booked By:</Typography>
                <Typography variant="body2">
                  {service.createdByUserName || "-"}
                </Typography>
              </Box>

              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <Typography variant="body2" sx={{ width: 150 }}>
                  Time of Booking:
                </Typography>
                <Typography variant="body2" align="right">
                  {convertUTCToTimeZoneDateTimeString(
                    service?.createdOn,
                    auth?.slectedFacility?.timeZone,
                  )}
                </Typography>
              </Box>
            </Box>
          </CardContent>
        </Card>
      );
    };

    // Render primary service card for mobile view
    const renderPrimaryServiceCard = () => {
      return (
        <Card variant="outlined" sx={{ mb: 2, borderRadius: 2, width: "100%" }}>
          <CardContent sx={{ padding: 2 }}>
            <Typography variant="subtitle1" fontWeight="bold" mb={1}>
              Primary Service Scheduled With
            </Typography>

            <Divider sx={{ my: 1 }} />

            <Box sx={{ "& > div": { mb: 1 } }}>
              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <Typography variant="body2">Name:</Typography>
                <Typography>{service?.assignedToUserName}</Typography>
              </Box>

              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <Typography variant="body2">Mobile:</Typography>
                <Typography>{service?.assignedToMobileNo}</Typography>
              </Box>

              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <Typography variant="body2">Email:</Typography>
                <Typography>{service.assignedToEmailId}</Typography>
              </Box>
            </Box>
          </CardContent>
        </Card>
      );
    };

    const renderPrescriptionCards = () => (
      <Box sx={{ width: "95%" }}>
        {combinedRows.map((prescription) => (
          <Card
            key={prescription.id}
            variant="outlined"
            sx={{ mb: 2, borderRadius: 2 }}
          >
            <CardContent>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                  mb: 1,
                }}
              >
                <Typography
                  variant="body1"
                  fontWeight="bold"
                  sx={{ flexGrow: 1 }}
                >
                  {prescription.sourceType === "medicalRecord"
                    ? prescription.name
                    : prescription.displayId}
                </Typography>
                <Chip
                  label={
                    prescription?.status ||
                    getDisplayValue(prescription?.noteType) ||
                    prescription?.recordType ||
                    "Not Assigned"
                  }
                  color={
                    prescription.status === "Draft"
                      ? "default"
                      : prescription.status === "Completed"
                        ? "success"
                        : "primary"
                  }
                  size="small"
                />
              </Box>

              <Divider sx={{ my: 1 }} />
              {prescription.sourceType === "clinicalnote" && (
                <>
                  <Typography variant="body2" sx={{ mb: 1 }}>
                    <strong>Created By:</strong>{" "}
                    {prescription.createdByUserName}
                  </Typography>

                  <Typography variant="body2" sx={{ mb: 1 }}>
                    <strong>Created On:</strong>{" "}
                    {convertUTCToTimeZoneDateTimeString(
                      prescription?.createdOn,
                      auth?.slectedFacility?.timeZone,
                    )}
                  </Typography>

                  <Typography variant="body2" sx={{ mb: 1 }}>
                    <strong>Last Modified On:</strong>{" "}
                    {convertUTCToTimeZoneDateTimeString(
                      prescription?.lastModifiedOn,
                      auth?.slectedFacility?.timeZone,
                    )}
                  </Typography>

                  <Typography variant="body2" sx={{ mb: 2 }}>
                    <strong>Last Modified By:</strong>{" "}
                    {prescription?.lastModifiedByUserName || ""}
                  </Typography>
                </>
              )}
              {prescription.sourceType === "prescription" && (
                <>
                  <Typography variant="body2" sx={{ mb: 1 }}>
                    <strong>Created By:</strong> {prescription.physicianName}
                  </Typography>

                  <Typography variant="body2" sx={{ mb: 1 }}>
                    <strong>Type:</strong>{" "}
                    {getDisplayValue(prescription.prescriptionType)}
                  </Typography>

                  <Typography variant="body2" sx={{ mb: 1 }}>
                    <strong>Created On:</strong>{" "}
                    {convertUTCToTimeZoneDateTimeString(
                      prescription?.createdOn,
                      auth?.slectedFacility?.timeZone,
                    )}
                  </Typography>

                  <Typography variant="body2" sx={{ mb: 2 }}>
                    <strong>Completion Time:</strong>{" "}
                    {convertUTCToTimeZoneDateTimeString(
                      prescription?.lastModifiedOn,
                      auth?.selectedFacility?.timeZone,
                    )}
                  </Typography>
                </>
              )}
              {prescription.sourceType === "medicalRecord" && (
                <>
                  <Typography variant="body2" sx={{ mb: 1 }}>
                    <strong>Record Date:</strong>{" "}
                    {convertUTCToTimeZoneDateString(
                      prescription?.recordDateTime,
                      auth?.slectedFacility?.timeZone,
                    )}
                  </Typography>

                  <Typography variant="body2" sx={{ mb: 1 }}>
                    <strong>Uploaded Date Time:</strong>{" "}
                    {convertUTCToTimeZoneDateTimeString(
                      prescription?.dateOfUpload,
                      auth?.slectedFacility?.timeZone,
                    )}
                  </Typography>

                  <Typography variant="body2" sx={{ mb: 2 }}>
                    <strong>Uploaded By:</strong>
                    {prescription.createdByUserName}
                  </Typography>
                </>
              )}
            </CardContent>

            <CardActions
              sx={{
                justifyContent: "flex-end",
                px: 2,
                pb: 2,
                flexWrap: "wrap",
                gap: 1,
              }}
            >
              {prescription?.status === "Draft" ? (
                <>
                  <Tooltip title="Edit Prescription" arrow>
                    <IconButton
                      size="small"
                      color="primary"
                      onClick={() =>
                        onEditPrescription(service?.id, prescription)
                      }
                    >
                      <CreateOutlined fontSize="small" />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Remove Prescription" arrow>
                    <IconButton
                      size="small"
                      color="secondary"
                      onClick={() => onRemovePrescriptionClick(prescription)}
                    >
                      <CloseOutlined fontSize="small" />
                    </IconButton>
                  </Tooltip>
                </>
              ) : (
                <Tooltip title="View Prescription" arrow>
                  <IconButton
                    size="small"
                    color="primary"
                    onClick={() =>
                      onViewPrescription(
                        prescription.id,
                        prescription.displayId,
                        prescription.prescriptionType,
                        serviceId,
                      )
                    }
                  >
                    <Visibility fontSize="small" />
                  </IconButton>
                </Tooltip>
              )}
            </CardActions>
          </Card>
        ))}

        {prescriptions.length === 0 && !isLoadingPrescriptions && (
          <Box sx={{ textAlign: "center", py: 4 }}>
            <Typography variant="body1" color="text.secondary">
              No prescriptions found
            </Typography>
          </Box>
        )}

        {isLoadingPrescriptions && (
          <Box sx={{ textAlign: "center", py: 4 }}>
            <Typography variant="body1" color="text.secondary">
              Loading...
            </Typography>
          </Box>
        )}
      </Box>
    );

    const renderClinicalNotesCards = () => (
      <Box sx={{ px: 1, maxHeight: "350px", overflowY: "auto" }}>
        {clinicalNotes.map((note) => (
          <Card
            key={note.id}
            variant="outlined"
            sx={{ mb: 2, borderRadius: 2 }}
          >
            <CardContent>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                  mb: 1,
                }}
              >
                <Typography
                  variant="body1"
                  fontWeight="bold"
                  sx={{ flexGrow: 1 }}
                >
                  {note.displayId}
                </Typography>
                <Chip label={note.noteType} color="primary" size="small" />
              </Box>

              <Divider sx={{ my: 1 }} />

              <Typography variant="body2" sx={{ mb: 1 }}>
                <strong>Created By:</strong> {note.createdByUserName}
              </Typography>

              <Typography variant="body2" sx={{ mb: 1 }}>
                <strong>Created On:</strong>{" "}
                {convertUTCToTimeZoneDateTimeString(
                  note?.createdOn,
                  auth?.slectedFacility?.timeZone,
                )}
              </Typography>

              <Typography variant="body2" sx={{ mb: 1 }}>
                <strong>Last Modified On:</strong>{" "}
                {convertUTCToTimeZoneDateTimeString(
                  note?.lastModifiedOn,
                  auth?.slectedFacility?.timeZone,
                )}
              </Typography>

              <Typography variant="body2" sx={{ mb: 2 }}>
                <strong>Last Modified By:</strong>{" "}
                {note?.lastModifiedByUserName || ""}
              </Typography>
            </CardContent>

            <CardActions
              sx={{
                justifyContent: "flex-end",
                px: 2,
                pb: 2,
                flexWrap: "wrap",
                gap: 1,
              }}
            >
              <Tooltip title="View Note" arrow>
                <IconButton
                  size="small"
                  color="primary"
                  onClick={() => onViewNote(service?.id, note)}
                >
                  <EditIcon fontSize="small" />
                </IconButton>
              </Tooltip>
              <Tooltip title="Remove Note" arrow>
                <IconButton
                  size="small"
                  color="secondary"
                  onClick={() => onRemoveNoteClick(note)}
                >
                  <CloseOutlined fontSize="small" />
                </IconButton>
              </Tooltip>
            </CardActions>
          </Card>
        ))}

        {clinicalNotes.length === 0 && !isLoadingNotes && (
          <Box sx={{ textAlign: "center", py: 4 }}>
            <Typography variant="body1" color="text.secondary">
              No Rows
            </Typography>
          </Box>
        )}

        {isLoadingNotes && (
          <Box sx={{ textAlign: "center", py: 4 }}>
            <Typography variant="body1" color="text.secondary">
              Loading...
            </Typography>
          </Box>
        )}
      </Box>
    );

    //combined grid column
    const combinedGridColumns = [
      {
        field: "displayId",
        headerName: "ID",
        width: 250,
        renderCell: (params) => {
          const row = params?.row || {};
          const displayId = row.displayId || row.name || "N/A";

          // Show three-dot menu for:
          // 1. Draft prescriptions and clinical notes (edit/remove)
          // 2. Finalized prescriptions and medical records (send to patient)
          const showMenu =
            (row.sourceType === "prescription" && row.status === "Draft") ||
            row.sourceType === "clinicalnote" ||
            (row.sourceType === "prescription" && row.status !== "Draft") ||
            row.sourceType === "medicalRecord"||
  row.sourceType === "Drawing";


          // Show hyperlink only for medical records and final prescriptions
          const showHyperlink =
            row.sourceType === "medicalRecord" ||
            (row.sourceType === "prescription" && row.status !== "Draft")||
              row.sourceType === "Drawing"; 

          return (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                width: "100%",
              }}
            >
              {showHyperlink ? (
                <span
                  style={{
                    textDecoration: "underline",
                    cursor: "pointer",
                    flex: 1,
                  }}
                  onClick={() => {
                    if (row.sourceType === "prescription") {
                      onViewPrescription(
                        row.id,
                        row.displayId,
                        row.prescriptionType,
                        serviceId,
                      );
                    } else if (row.sourceType === "medicalRecord") {
                      handlePreviewMedicalRecord(row);
  } else if (row.sourceType === "Drawing") {
  onOpenSavedTLDraw && onOpenSavedTLDraw(row.diagramId, row.displayId, serviceId);
}
                  }}
                >
                  {displayId}
                </span>
              ) : (
                <span style={{ flex: 1 }}>{displayId}</span>
              )}

              {showMenu && (
                <Tooltip title="Actions" arrow>
                  <IconButton
                    size="small"
                    onClick={(event) => handleRowMenuOpen(event, row)}
                  >
                    <MoreVert fontSize="small" />
                  </IconButton>
                </Tooltip>
              )}
            </Box>
          );
        },
      },

      {
        field: "type",
        headerName: "Type",
        width: 250,
        valueGetter: (params) => {
          const row = params?.row || {};
          return row.prescriptionType || row.noteType || row.recordType || "";
        },
        renderCell: (params) => {
          const row = params?.row || {};
          return getDisplayValue(
            row.prescriptionType || row.noteType || row.recordType || "",
          );
        },
      },
      {
        field: "status",
        headerName: "Status",
        width: 200,
        renderCell: (params) => {
          const row = params?.row || {};
          return row.status || "Not Applicable";
        },
      },
      {
        field: "createdByUserName",
        headerName: "Created By / Uploaded By",
        width: 250,
      },
      {
        field: "createdOn",
        headerName: "Created On / Uploaded On",
        width: 260,
        renderCell: (params) => {
          const row = params?.row || {};
          return convertUTCToTimeZoneDateTimeString(
            row.createdOn,
            auth?.slectedFacility?.timeZone,
          );
        },
      },
    ];

    useEffect(() => {
      const getService = async () => {
        setIsLoadingServiceData(true);
        const result = await getServiceDetails(auth, serviceId);
        if (result?.isSuccess) {
          console.log("Service Details API Response:", result?.data);
          setIsLoadingServiceData(false);
          setService(result?.data);
        } else {
          setIsLoadingServiceData(false);
          showSnackbar("Failed to load service details", "error");
        }
      };

      const loadPrescriptions = async () => {
        if (auth != null && serviceId != null) {
          setIsLoadingPrescriptions(true);
          var result = await getPrescriptionsForService(auth, serviceId);
          if (result?.isSuccess) {
            setPrescriptions(result.data);
          } else {
            showSnackbar("Failed to load prescriptions", "error");
            //setIsLoadingPrescriptions(false);
          }
          setIsLoadingPrescriptions(false);
        }
      };
      const loadClinicalNotes = async () => {
        if (auth != null && serviceId != null) {
          setIsLoadingNotes(true);
          var result = await getClinicalNotesForService(auth, serviceId);
          if (result?.isSuccess) {
            setClinicalNotes(result.data);
          } else {
            showSnackbar("Failed to load clinical notes", "error");
          }
          setIsLoadingNotes(false);
        }
      };

      const loadMedicalRecords = async () => {
        if (auth != null && serviceId != null) {
          setIsLoadingMedicalRecords(true);
          var result = await getMedicalRecordMetadata(auth, serviceId);
          if (result?.isSuccess) {
            setMedicalRecords(result.data);
          } else {
            showSnackbar("Failed to load medical records", "error");
          }
          setIsLoadingMedicalRecords(false);
        }
      };

      getService();
      loadPrescriptions();
      loadClinicalNotes();
      loadMedicalRecords();
      refreshWhiteboards(); 
    }, [auth, serviceId]);

    const onRemovePrescriptionClick = async (prescription) => {
      if (auth != null && prescription != null) {
        var result = await removePrescription(auth, prescription?.id);
        if (result?.isSuccess) {
          refreshPrescriptions();
        }
      }
      settempRowIdForDelete(null);
      setOpenUndoDialog(false);
    };

    const onRemoveNoteClick = async (note) => {
      if (auth != null && note != null) {
        try {
          var result = await deleteClinicalNote(auth, note?.id);
          if (result?.isSuccess) {
            refreshClinicalNotes();
          }
        } catch (error) {
          console.error("Error deleting clinical note:", error);
        }
      }
      settempRowIdForDelete(null);
      setOpenUndoDialog(false);
    };

    const onRemoveDrawingClick = async (drawing) => {
  if (auth && drawing?.diagramId) {
    try {
      const result = await deleteDiagram(auth, drawing.diagramId);
      if (result?.isSuccess) {
        showSnackbar("Whiteboard deleted successfully", "success");
        await refreshWhiteboards();
      } else {
        showSnackbar("Failed to delete whiteboard: " + result?.data, "error");
      }
    } catch (e) {
      console.error("Error deleting whiteboard:", e);
      showSnackbar("Error deleting whiteboard", "error");
    }
  }
  settempRowIdForDelete(null);
  setOpenUndoDialog(false);
};

    const handlePreviewMedicalRecord = async (record) => {
      if (auth != null && record != null) {
        setSelectedRecord(record);
        setPreviewDialogOpen(true);
        setPreviewLoading(true);

        try {
          const result = await downloadMedicalRecord(auth, record.id);

          if (result?.isSuccess && result.data) {
            // Create a blob from the response data WITHOUT auto-downloading
            // const blob = new Blob([result.data]);
            // const url = window.URL.createObjectURL(blob);
            // window.open(url, "_blank"); // Open in a new tab for preview
            const fileBlob = new Blob([result.data], {
              type: result.contentType, // or whatever type you expect
            });

            // Create blob URL for preview only
            const blobUrl = URL.createObjectURL(fileBlob);
            window.open(blobUrl, result.fileName); // Open in a new tab for preview
            setSelectedRecord({
              ...record,
              fileBlob: fileBlob, // Store the blob directly
              blobUrl: blobUrl,
              fileName: result.fileName || record.name,
            });
          } else {
            console.error("Failed to preview medical record");
          }
        } catch (error) {
          console.error("Error previewing medical record:", error);
        } finally {
          setPreviewLoading(false);
        }
      }
    };
    const refreshMedicalRecords = async () => {
      if (auth != null && serviceId != null) {
        try {
          setIsLoadingMedicalRecords(true);
          var result = await getMedicalRecordMetadata(auth, serviceId);
          if (result?.isSuccess) {
            setMedicalRecords(result.data);
          } else {
            showSnackbar("Failed to load medical records", "error");
          }
        } catch (error) {
          console.error("Error loading medical records:", error);
        } finally {
          setIsLoadingMedicalRecords(false);
        }
      }
    };

    const refreshPrescriptions = async () => {
      if (auth != null && serviceId != null) {
        try {
          setIsLoadingPrescriptions(true);
          var result = await getPrescriptionsForService(auth, serviceId);
          if (result?.isSuccess) {
            setPrescriptions(result.data);
          }
        } catch (error) {
          console.error("Error refreshing prescriptions:", error);
        } finally {
          setIsLoadingPrescriptions(false);
        }
      }
    };

    const refreshClinicalNotes = async () => {
      if (auth != null && serviceId != null) {
        try {
          setIsLoadingNotes(true);
          var result = await getClinicalNotesForService(auth, serviceId);
          if (result?.isSuccess) {
            setClinicalNotes(result.data);
          }
        } catch (error) {
          console.error("Error loading clinical notes:", error);
        } finally {
          setIsLoadingNotes(false);
        }
      }
    };
 const refreshWhiteboards = async () => {
  if (auth && serviceId) {
    try {
      const result = await getDiagrams(auth, serviceId);
      if (result?.isSuccess) {
        setWhiteboards(result.data || []);
      } else {
        showSnackbar("Failed to load whiteboards", "error");
      }
    } catch (e) {
      console.error("Error loading whiteboards:", e);
    }
  }
};

    useImperativeHandle(ref, () => ({
      refreshPrescriptions,
      refreshClinicalNotes,
      refreshMedicalRecords,
       refreshWhiteboards,
    }));

    const [combinedRows, setCombinedRows] = useState([]);

   useEffect(() => {
  if (prescriptions || clinicalNotes || medicalRecords || whiteboards) {
    const unifiedPrescriptions = prescriptions.map((item) => ({
      ...item,
      sourceType: "prescription",
      id: `${item.id}`,
      createdByUserName: item.physicianName,
      type: item.prescriptionType,
    }));

    const unifiedNotes = clinicalNotes.map((item) => ({
      ...item,
      sourceType: "clinicalnote",
      id: `${item.id}`,
      createdByUserName: item.createdByUserName,
      type: item.noteType,
    }));

    const unifiedMedicalRecords = medicalRecords.map((item) => ({
      ...item,
      sourceType: "medicalRecord",
      id: `${item.id}`,
      createdByUserName: item.createdByUserName,
      type: item.recordType,
    }));

    // ✅ ADD
   const unifiedWhiteboards = whiteboards.map((item) => ({
  ...item,
  sourceType: "Drawing",
  id: String(item.id),
  displayId: item.name,
  createdByUserName: item.createdByUserName || "",
  type: "Whiteboard",
  status: "Saved",
  recordType: "Drawing",
  createdOn: item.createdOn,
  diagramId: item.id,
}));

    setCombinedRows([
      ...unifiedPrescriptions,
      ...unifiedNotes,
      ...unifiedMedicalRecords,
      ...unifiedWhiteboards,  // ✅ ADD
    ]);
  }
}, [prescriptions, clinicalNotes, medicalRecords, whiteboards]); 

 return (
  <>
    {/* ✅ Sticky action bar */}
   {/* ✅ Sticky action bar */}
<Grid2
  container
  size={12}
  sx={{
    position: "sticky",
    top: 0,
    zIndex: 1100,
    backgroundColor: "white",
  }}
>
  <Grid2
    container
    size={12}
    pb={0.5} pt={0.5} pl={1}
    sx={{ borderBottom: "2px solid lightgray", width: "100%" }}
    spacing={1}
  >
    {service?.status !== ServiceStatus.InProgress &&
      service?.status !== ServiceStatus.Completed && (
        <GenericActionButton
          label="Start Service"
          icon={<PlayCircleOutline />}
          onClick={() => updateServiceStatus(ServiceStatus.InProgress)}
          disabled={isUpdatingStatus}
          tooltipText="Start Service"
        />
      )}

    {(service?.status === ServiceStatus.InProgress ||
      service?.status === ServiceStatus.Completed) && (
      <GenericActionButton
        label="Undo Status"
        icon={<Undo />}
        onClick={handleUndoServiceStatus}
        disabled={isUpdatingStatus}
        tooltipText="Undo Status"
      />
    )}

    {service?.status === ServiceStatus.InProgress && (
      <GenericActionButton
        label="Complete Service"
        icon={<Done />}
        onClick={() => updateServiceStatus(ServiceStatus.Completed)}
        disabled={isUpdatingStatus}
        tooltipText="Complete Service"
      />
    )}

    {service?.status === ServiceStatus.InProgress &&
      viewModeConfig.showAddRecord && (
        <GenericActionButton
          label="Add Record"
          icon={<AddRounded />}
          onClick={(event) => {
            setAddPrescriptionMenuAnchor(event.currentTarget);
            setShowAddPrescriptionrMenu(true);
          }}
          disabled={isUpdatingStatus}
          tooltipText="Add Medical Record/Prescription/Notes"
        />
      )}
  </Grid2>
</Grid2>

    {/* Scrollable content */}
    <Grid2
      container
      spacing={2}
      sx={{
        paddingX: "5px",
        paddingTop: "5px",
        paddingBottom: "50px",
        maxHeight: "calc(100vh - 150px)",
        overflowY: "auto",
      }}
    >
      
          {(isLoadingServiceData ||
            isLoadingPrescriptions ||
            isLoadingNotes ||
            isLoadingMedicalRecords) && <LoadingScreen />}
         
          <Grid2 container size={12} sx={{ paddingX: "5px" }}>
            {isMobile ? (
  // Mobile view layout using cards
  <Grid2 container size={12} sx={{ px: 1, overflow: "auto" }}>
    {renderPatientDetailsCard()}
    {renderVisitDetailsCard()}
    {renderPrimaryServiceCard()}
  </Grid2>
) : (
              <Grid2 container size={12} sx={{ paddingX: "5px" }}>
                {/* Patient Details Card */}
                <Grid2
                  container
                  size={{ xs: 12, sm: 12, md: 12, lg: 4, xl: 4 }}
                >
                  <Card variant="outlined" sx={{ width: "100%" }}>
                    <CardHeader subheader="Patient's Details"></CardHeader>
                    <CardContent>
                      <Grid2 container size={12}>
                        <Grid2 size={9}>
                          <Grid2 container size={12}>
                            <Grid2 size={3}>
                              <Typography>Name</Typography>
                            </Grid2>
                            <Grid2 size={9}>
                              <span
                                style={{
                                  textDecoration: "underline",
                                  cursor: "pointer",
                                }}
                                onClick={() =>
                                  onViewPatientDetails &&
                                  onViewPatientDetails({
                                    id: service?.patientId,
                                    firstName: service?.patientFirstName,
                                    lastName: service?.patientLastName,
                                  })
                                }
                              >
                                {service?.patientFirstName}&nbsp;
                                {service?.patientLastName}
                              </span>
                            </Grid2>
                          </Grid2>
                          <Grid2 container size={12}>
                            <Grid2 size={3}>
                              <Typography>MRN</Typography>
                            </Grid2>
                            <Grid2 size={9}>
                              <Typography>
                                {service?.patientMRN}&nbsp;
                              </Typography>
                            </Grid2>
                          </Grid2>
                          <Grid2 container size={12}>
                            <Grid2 size={3}>
                              <Typography>Age</Typography>
                            </Grid2>
                            <Grid2 size={9}>
                              <Typography>
                                {formatAge(service?.patientAgeInYears)}
                              </Typography>
                            </Grid2>
                          </Grid2>
                          <Grid2 container size={12}>
                            <Grid2 size={3}>
                              <Typography>Gender</Typography>
                            </Grid2>
                            <Grid2 size={9}>
                              <Typography>{service?.patientGender}</Typography>
                            </Grid2>
                          </Grid2>
                          <Grid2 container size={12}>
                            <Grid2 size={3}>
                              <Typography>Mobile</Typography>
                            </Grid2>
                            <Grid2 size={9}>
                              <Typography sx={{ overflowWrap: "break-word" }}>
                                {service?.patientMobileNo}
                              </Typography>
                            </Grid2>
                            <Grid2 size={3}>
                              <Typography>Email</Typography>
                            </Grid2>
                            <Grid2 size={9}>
                              <Typography sx={{ overflowWrap: "break-word" }}>
                                {service?.patientEmailId}
                              </Typography>
                            </Grid2>
                          </Grid2>
                        </Grid2>
                        <Grid2
                          container
                          size={3}
                          sx={{
                            overflow: "hidden",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <img
                            src={
                              service?.patient?.photo
                                ? service?.patient?.photo
                                : service?.patientGender === "Male"
                                  ? "./placeholder-image-male-gender.webp"
                                  : "./placeholder-image-female-gender.webp"
                            }
                            className="border rounded p-0"
                            alt="PatientPhoto"
                            width="120"
                            height="120"
                          />
                        </Grid2>
                      </Grid2>
                    </CardContent>
                  </Card>
                </Grid2>

                {/* Visit Details Card */}
                <Grid2
                  container
                  size={{ xs: 12, sm: 12, md: 12, lg: 4, xl: 4 }}
                >
                  <Grid2 size={12}>
                    <Card
                      variant="outlined"
                      sx={{ width: "100%", height: "100%" }}
                    >
                      <CardHeader subheader="Visit Details"></CardHeader>
                      <CardContent>
                        <Grid2 container size={12}>
                          <Grid2 size={4}>
                            <Typography>Visit Id</Typography>
                          </Grid2>
                          <Grid2 size={8}>
                            {/* <span
              style={{
                textDecoration: "underline",
                cursor: "pointer",
              }}
              onClick={() =>
                onViewVisitDetails &&
                onViewVisitDetails({
                  id: service?.visitId,
                  displayId: service?.visitDisplayId,
                  // Pass all the patient data from service
                  patientId: service?.patientId,
                  patientFirstName: service?.patientFirstName,
                  patientLastName: service?.patientLastName,
                  patientMRN: service?.patientMRN,
                  patientAgeInYears: service?.patientAgeInYears,
                  patientGender: service?.patientGender,
                  patientMobileNo: service?.patientMobileNo,
                  patientEmailId: service?.patientEmailId,
                  // Pass visit details
                  visitStatus: service?.visitStatus,
                  appointmentDateTime:
                    service?.scheduledStartDateTime,
                  createdByUserName: service?.createdByUserName,
                  createdOn: service?.createdOn,
                  // Pass physician details
                  physicianPrefix: service?.physicianPrefix,
                  physicianFirstName: service?.physicianFirstName,
                  physicianLastName: service?.physicianLastName,
                  physicianSuffix: service?.physicianSuffix,
                  physicianProfessionalId:
                    service?.physicianProfessionalId,
                  physicianMobileNo: service?.physicianMobileNo,
                  physicianEmailId: service?.physicianEmailId,
                  assignedToUserName: service?.assignedToUserName,
                  // Pass any other relevant data available in service object
                  advanceAmount: service?.advanceAmount,
                  visitType: service?.visitType,
                  location: service?.location,
                  visitDateTime: service?.scheduledStartDateTime,
                })
              }
            >
              {service.visitDisplayId}
            </span> */}

                            {/* <span
              style={{
                textDecoration: "underline",
                cursor: "pointer",
              }}
              onClick={async () => {
                try {
                  console.log(
                    "Clicking Visit ID:",
                    service?.visitId
                  );
                  console.log(
                    "Facility ID:",
                    auth?.selectedFacility?.id
                  );

                  const result = await getVisitByFacility(
                    auth,
                    service?.visitId,
                    auth?.selectedFacility?.id
                  );

                  console.log("API Result:", result);
                  console.log("API Data:", result?.data);

                  if (result?.isSuccess && result?.data) {
                    console.log(
                      "Calling onViewVisitDetails with:",
                      result.data
                    );
                    onViewVisitDetails &&
                      onViewVisitDetails(result.data);
                  } else {
                    showSnackbar(
                      "Failed to load visit details",
                      "error"
                    );
                  }
                } catch (error) {
                  console.error(
                    "Error loading visit details:",
                    error
                  );
                  showSnackbar(
                    "Error loading visit details",
                    "error"
                  );
                }
              }}
            >
              {service.visitDisplayId}
            </span> */}
                            <span
                              style={{
                                textDecoration: "underline",
                                cursor: "pointer",
                              }}
                              onClick={async () => {
                                //const data = await handleFetchVisitDetails(service?.visitId);
                                onViewVisitDetails &&
                                  onViewVisitDetails(
                                    service?.visitId,
                                    service?.visitDisplayId,
                                  );
                              }}
                            >
                              {service.visitDisplayId}
                            </span>
                          </Grid2>
                        </Grid2>
                        <Grid2 container size={12}>
                          <Grid2 size={4}>
                            <Typography>Status</Typography>
                          </Grid2>
                          <Grid2 size={8}>
                            <Typography>
                              {getDisplayValue(service?.visitStatus)}
                            </Typography>
                          </Grid2>
                        </Grid2>
                        <Grid2 container size={12}>
                          <Grid2 size={4}>
                            <Typography>Referred By</Typography>
                          </Grid2>
                          <Grid2 size={8}>
                            <Typography>{service?.referredBy}</Typography>
                          </Grid2>
                        </Grid2>
                        <Grid2 container size={12}>
                          <Grid2 size={4}>
                            <Typography>Scheduled At</Typography>
                          </Grid2>
                          <Grid2 size={8}>
                            <Typography>
                              {convertUTCToTimeZoneDateTimeString(
                                service?.scheduledStartDateTime,
                                auth?.slectedFacility?.timeZone,
                              )}
                            </Typography>
                          </Grid2>
                        </Grid2>
                        <Grid2 container size={12}>
                          <Grid2 size={4}>
                            <Typography>Booked By</Typography>
                          </Grid2>
                          <Grid2 size={8}>
                            <Typography>{service.createdByUserName}</Typography>
                          </Grid2>
                        </Grid2>
                        <Grid2 container size={12}>
                          <Grid2 size={4}>
                            <Typography>Time of Booking</Typography>
                          </Grid2>
                          <Grid2 size={8}>
                            <Typography>
                              {convertUTCToTimeZoneDateTimeString(
                                service?.createdOn,
                                auth?.slectedFacility?.timeZone,
                              )}
                              {/* {convertUTCToTimeZone(service?.createdOn, auth?.slectedFacility?.timeZone)} */}
                            </Typography>
                          </Grid2>
                        </Grid2>
                      </CardContent>
                    </Card>
                  </Grid2>
                </Grid2>

                {/* Physician Details Card */}
                <Grid2
                  container
                  size={{ xs: 12, sm: 12, md: 12, lg: 4, xl: 4 }}
                >
                  <Card variant="outlined" sx={{ width: "100%" }}>
                    <CardHeader subheader="Primary Service Scheduled With"></CardHeader>
                    <CardContent>
                      <Grid2 container size={12}>
                        <Grid2 size={3}>
                          <Typography>Name</Typography>
                        </Grid2>
                        <Grid2 size={9}>
                          <Typography>{service?.assignedToUserName}</Typography>
                        </Grid2>
                      </Grid2>
                      {/* <Grid2 container size={12}>
          <Grid2 size={3}>
            <Typography>ID</Typography>
          </Grid2>
          <Grid2 size={9}>
            <Typography>{service.assignedToId}&nbsp;</Typography>
          </Grid2>
        </Grid2> */}
                      <Grid2 container size={12}>
                        <Grid2 size={3}>
                          <Typography>Mobile</Typography>
                        </Grid2>
                        <Grid2 size={9}>
                          <Typography>{service?.assignedToMobileNo}</Typography>
                        </Grid2>
                      </Grid2>
                      <Grid2 container size={12}>
                        <Grid2 size={3}>
                          <Typography>Email</Typography>
                        </Grid2>
                        <Grid2 size={9}>
                          <Typography>{service?.assignedToEmailId}</Typography>
                        </Grid2>
                      </Grid2>
                    </CardContent>
                  </Card>
                </Grid2>
              </Grid2>
            )}

            {/* ------------------------datagrid all in one (Merge all in this) ----------------------------------------------- */}

           <Grid2
  container
  size={12}
  sx={{ height: isMobile ? "auto" : "400px", mt: 2 }}
>
  <Card
    variant="outlined"
    sx={{
      width: "100%",
      height: isMobile ? "auto" : "400px",
      display: "flex",
      flexDirection: "column",
    }}
  >
                <CardHeader
                  subheader={
                    <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                      {/* <Typography variant="subtitle2">All Medical Records</Typography> */}
                      {/* <Typography
                    component="span"
                    onClick={(event) => {
                      setAddPrescriptionMenuAnchor(event.currentTarget);
                      setShowAddPrescriptionrMenu(true);
                    } }
                    sx={{
                      cursor: "pointer",
                      textDecoration: "underline",

                      "&:hover": {
                        color: "primary.dark",
                      },
                    }}
                  >
                    Add New Record
                  </Typography> */}
                    </Box>
                  }
                  sx={{ paddingY: "10px" }}
                />

                <Menu
                  anchorEl={addPrescriptionMenuAnchor}
                  open={
                    Boolean(addPrescriptionMenuAnchor) &&
                    showAddPrescriptionrMenu
                  }
                  onClose={() => {
                    setAddPrescriptionMenuAnchor(null);
                    setShowAddPrescriptionrMenu(false);
                  }}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                  }}
                >
                  {(() => {
                    const allowedTypes =
                      auth?.selectedFacility?.licenseDetails
                        ?.allowedPrescriptions ||
                      AvailablePrescriptionTypes.map((type) => type.value);

                    return (
                      <>
                        {allowedTypes.includes(
                          PrescriptionTypes.GeneralPrescription,
                        ) && (
                          <MenuItem
                            disabled={service?.status !== "InProgress"}
                            onClick={() => {
                              onAddNewPrescription(
                                serviceId,
                                PrescriptionTypes.GeneralPrescription,
                                service?.patientFirstName +
                                  " " +
                                  service?.patientLastName,
                              );
                              setShowAddPrescriptionrMenu(false);
                              setAddPrescriptionMenuAnchor(null);
                            }}
                          >
                            {getLabelOfPrescriptionTypes(
                              PrescriptionTypes.GeneralPrescription,
                            )}
                          </MenuItem>
                        )}

                        {allowedTypes.includes(
                          PrescriptionTypes.PhysiotherapyPrescription,
                        ) && (
                          <MenuItem
                            disabled={service?.status !== "InProgress"}
                            onClick={() => {
                              onAddNewPrescription(
                                serviceId,
                                PrescriptionTypes.PhysiotherapyPrescription,
                                service?.patientFirstName +
                                  " " +
                                  service?.patientLastName,
                              );
                              setShowAddPrescriptionrMenu(false);
                              setAddPrescriptionMenuAnchor(null);
                            }}
                          >
                            {getLabelOfPrescriptionTypes(
                              PrescriptionTypes.PhysiotherapyPrescription,
                            )}
                          </MenuItem>
                        )}

                        {allowedTypes.includes(
                          PrescriptionTypes.PathologyLabReport,
                        ) && (
                          <MenuItem
                            disabled={service?.status !== "InProgress"}
                            onClick={() => {
                              onAddNewPrescription(
                                serviceId,
                                PrescriptionTypes.PathologyLabReport,
                                service?.patientFirstName +
                                  " " +
                                  service?.patientLastName,
                              );
                              setShowAddPrescriptionrMenu(false);
                              setAddPrescriptionMenuAnchor(null);
                            }}
                          >
                            {getLabelOfPrescriptionTypes(
                              PrescriptionTypes.PathologyLabReport,
                            )}
                          </MenuItem>
                        )}
                        {allowedTypes.includes(
                          PrescriptionTypes.FrozenShoulder,
                        )
                        
                         && (
                          <MenuItem
                            disabled={service?.status !== "InProgress"}
                            onClick={() => {
                              onAddNewPrescription(
                                serviceId,
                                PrescriptionTypes.FrozenShoulder,
                                service?.patientFirstName +
                                  " " +
                                  service?.patientLastName,
                              );
                              setShowAddPrescriptionrMenu(false);
                              setAddPrescriptionMenuAnchor(null);
                            }}
                          >
                            {getLabelOfPrescriptionTypes(
                              PrescriptionTypes.FrozenShoulder,
                            )}
                          </MenuItem>
                        )}
                        {allowedTypes.includes(
  PrescriptionTypes.DentalPrescription,
) && (
  <MenuItem
    disabled={service?.status !== "InProgress"}
    onClick={() => {
      onAddNewPrescription(
        serviceId,
        PrescriptionTypes.DentalPrescription,
        service?.patientFirstName + " " + service?.patientLastName,
      );
      setShowAddPrescriptionrMenu(false);
      setAddPrescriptionMenuAnchor(null);
    }}
  >
    {getLabelOfPrescriptionTypes(PrescriptionTypes.DentalPrescription)}
  </MenuItem>
)}
                        {(allowedTypes.includes("General") ||
                          allowedTypes.includes("PhysiotherapyTreatment")) && (
                          <MenuItem
                            disabled={service?.status !== "InProgress"}
                            onClick={() => {
                              onAddNote(serviceId);
                              setShowAddPrescriptionrMenu(false);
                              setAddPrescriptionMenuAnchor(null);
                            }}
                          >
                            {getLabelOfPrescriptionTypes(NoteTypes[2].value)}
                          </MenuItem>
                        )}

                        {allowedTypes.includes("MedicalRecord") && (
                          <MenuItem
                            disabled={service?.status !== "InProgress"}
                            onClick={() => {
                              onAddMedicalRecord(serviceId);
                              setShowAddPrescriptionrMenu(false);
                              setAddPrescriptionMenuAnchor(null);
                            }}
                          >
                            {getLabelOfPrescriptionTypes(
                              MedicalRecordTypes[0].value,
                            )}
                          </MenuItem>
                        )}
                        {allowedTypes.includes("Whiteboard") && (
  <MenuItem
    disabled={service?.status !== "InProgress"}
    onClick={() => {
      onAddTLDraw && onAddTLDraw(serviceId);
      setShowAddPrescriptionrMenu(false);
      setAddPrescriptionMenuAnchor(null);
    }}
  >
   Drawing
  </MenuItem>
)}
                      </>
                    );
                  })()}
                </Menu>
             <CardContent
  sx={{
    border: "1px",
    height: isMobile ? "auto" : "90%",
    overflow: isMobile ? "visible" : "hidden",
    flex: isMobile ? undefined : 1,
  }}
>
  {isMobile ? (
    // Mobile view - Cards
    <Box sx={{ maxHeight: "60vh", overflow: "auto", px: 1 }}>
      {renderPrescriptionCards()}
    </Box>
  ) : (
                    // Desktop view - DataGrid
                    <DataGrid
  rows={combinedRows}
  columns={combinedGridColumns}
  hideFooter
  getRowHeight={() => "auto"}
  sx={{
    height: "100%",
    "& .sticky-column": {
      position: "sticky",
      right: 0,
      backgroundColor: "white",
      zIndex: 100,
    },
    "& .MuiDataGrid-cell": {
      display: "flex",
      alignItems: "center",
      whiteSpace: "normal",
      padding: "10px 12px",
      lineHeight: 1.5,
    },
    "& .MuiTablePagination-toolbar": {
      minHeight: "unset",
      alignItems: "center",
      paddingTop: "0 !important",
      paddingBottom: "0 !important",
    },
    "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows": {
      margin: 0,
    },
  }}
/>
                  )}
                </CardContent>
              </Card>
              {/* Row Menu for Remove - Add this after the DataGrid */}

              {/* Row Menu for Remove/Edit/Send - Add this after the DataGrid */}

              <Menu
                anchorEl={rowMenuAnchor}
                open={Boolean(rowMenuAnchor)}
                onClose={handleRowMenuClose}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "right",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
              >
                {/* Show Edit/Remove for draft prescriptions and clinical notes */}
                {((selectedRowForMenu?.sourceType === "prescription" &&
                  selectedRowForMenu?.status === "Draft") ||
                  selectedRowForMenu?.sourceType === "clinicalnote") && (
                  <>
                    <MenuItem
                      onClick={() => handleEditClick(selectedRowForMenu)}
                    >
                      <ListItemIcon>
                        <CreateOutlined fontSize="small" />
                      </ListItemIcon>
                      Edit
                    </MenuItem>
                    <MenuItem
                      onClick={() => handleRemoveClick(selectedRowForMenu)}
                    >
                      <ListItemIcon>
                        <CloseOutlined fontSize="small" />
                      </ListItemIcon>
                      Remove
                    </MenuItem>
                  </>
                )}

                {/* Show Send to Patient for finalized prescriptions and medical records */}
                {/* Notes ke liye abhi send option nahi hai */}
                {((selectedRowForMenu?.sourceType === "prescription" &&
                  selectedRowForMenu?.status !== "Draft") ||
                  selectedRowForMenu?.sourceType === "medicalRecord") && (
                  <MenuItem
                    onClick={() => handleSendToPatientClick(selectedRowForMenu)}
                  >
                    <ListItemIcon>
                      <SendIcon fontSize="small" />
                    </ListItemIcon>
                    Send to Patient
                  </MenuItem>
                )}
                {selectedRowForMenu?.sourceType === "Drawing" && (
  <>
    <MenuItem
      onClick={() => {
        onOpenSavedTLDraw && onOpenSavedTLDraw(
          selectedRowForMenu.diagramId,
          selectedRowForMenu.displayId,
          serviceId,
        );
        handleRowMenuClose();
      }}
    >
      <ListItemIcon>
        <Visibility fontSize="small" />
      </ListItemIcon>
      View Whiteboard
    </MenuItem>
    <MenuItem
      onClick={() => {
        onOpenSavedTLDraw && onOpenSavedTLDraw(
          selectedRowForMenu.diagramId,
          selectedRowForMenu.displayId,
          serviceId,
        );
        handleRowMenuClose();
      }}
    >
      <ListItemIcon>
        <CreateOutlined fontSize="small" />
      </ListItemIcon>
      Edit
    </MenuItem>
    <MenuItem
      onClick={() => handleRemoveClick(selectedRowForMenu)}
    >
      <ListItemIcon>
        <CloseOutlined fontSize="small" />
      </ListItemIcon>
      Remove
    </MenuItem>
  </>
)}
             
              </Menu>
            </Grid2>
          </Grid2>
        </Grid2>
        
        <ConfirmationDialog
          open={openUndoDialog}
          onClose={() => setOpenUndoDialog(false)}
          onConfirm={() => {
            if (tempRowIdForDelete?.sourceType === "prescription") {
              onRemovePrescriptionClick(tempRowIdForDelete);
            } else if (tempRowIdForDelete?.sourceType === "clinicalnote") {
              onRemoveNoteClick(tempRowIdForDelete);
              } else if (tempRowIdForDelete?.sourceType === "Drawing") {
    onRemoveDrawingClick(tempRowIdForDelete);
            } else {
              confirmUndoStatus();
            }
          }}
          title={
            tempRowIdForDelete?.sourceType === "prescription"
              ? "Confirm Remove Prescription"
              : tempRowIdForDelete?.sourceType === "clinicalnote"
                ? "Confirm Remove Clinical Note"
                : tempRowIdForDelete?.sourceType === "Drawing"
        ? "Confirm Remove Whiteboard"
                : "Confirm Undo Status"
          }
          okButtonColor="secondary"
         statement={
  tempRowIdForDelete?.sourceType === "prescription"
    ? "Are you sure you want to remove this prescription? You can't get it back or undo this."
    : tempRowIdForDelete?.sourceType === "clinicalnote"
      ? "Are you sure you want to remove this clinical note? You can't get it back or undo this."
      : tempRowIdForDelete?.sourceType === "Drawing"
        ? "Are you sure you want to remove this whiteboard? You can't get it back or undo this."
        : service?.status === ServiceStatus.Completed
          ? "Are you sure you want to change status from Completed to In Progress?"
          : service?.status === ServiceStatus.InProgress
            ? "Are you sure you want to change status from In Progress to Not Started?"
            : "Are you sure you want to undo this status?"
}
        />
        {/* Send to Patient Dialog */}
        <Dialog
          open={sendToPatientDialogOpen}
          onClose={() => {
            if (!isSending) {
              setSendToPatientDialogOpen(false);
              setSelectedRowForSend(null);
            }
          }}
        >
          <DialogTitle>Send to Patient</DialogTitle>
          <DialogContent dividers>
            <Grid2 container spacing={2} sx={{ py: 2, minWidth: 400 }}>
              <Grid2 size={12}>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Do you want to send{" "}
                  <strong>
                    {selectedRowForSend?.sourceType === "prescription"
                      ? "Prescription"
                      : "Medical Record"}
                  </strong>{" "}
                  <strong>
                    "{selectedRowForSend?.displayId || selectedRowForSend?.name}
                    "
                  </strong>{" "}
                  to patient{" "}
                  <strong>
                    {service?.patientFirstName} {service?.patientLastName}
                  </strong>
                  ?
                </Typography>
              </Grid2>

              <Grid2 size={12}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Typography variant="body2">
                    <strong>Email:</strong>
                  </Typography>
                  <Typography
                    variant="body2"
                    color={service?.patientEmailId ? "text.primary" : "error"}
                  >
                    {service?.patientEmailId || "Email not available"}
                  </Typography>
                </Box>
              </Grid2>
            </Grid2>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                setSendToPatientDialogOpen(false);
                setSelectedRowForSend(null);
              }}
              variant="outlined"
              color="inherit"
              disabled={isSending}
            >
              Cancel
            </Button>
            <Button
              onClick={() => handleSendToPatient("email")}
              disabled={!service?.patientEmailId || isSending}
              variant="contained"
              color="secondary"
              startIcon={<SendIcon />}
            >
              {isSending ? "Sending..." : "Send"}
            </Button>
          </DialogActions>
        </Dialog>
         {/* <Dialog
          open={whiteboardPreviewOpen}
          onClose={() => {
            setWhiteboardPreviewOpen(false);
            setWhiteboardPreviewEntry(null);
          }}
          maxWidth="lg"
          fullWidth
          PaperProps={{ sx: { height: "85vh" } }}
        >
          <DialogTitle>
            {whiteboardPreviewEntry?.name || "Whiteboard Preview"}
          </DialogTitle>
          <DialogContent
            dividers
            sx={{ p: 0, overflow: "hidden", height: "100%" }}
          >
            {whiteboardPreviewOpen && whiteboardPreviewEntry && (
              <WhiteboardPreviewCanvas entry={whiteboardPreviewEntry} />
            )}
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                setWhiteboardPreviewOpen(false);
                setWhiteboardPreviewEntry(null);
              }}
              variant="outlined"
            >
              Close
            </Button>
          </DialogActions>
        </Dialog> */}
      </>
    );
  },
);

export default WorkItemDetails;
// function WhiteboardPreviewCanvas({ entry }) {
//   const canvasRef = useRef(null);
//   const fabricRef = useRef(null);
//   const isDisposed = useRef(false);

//   useEffect(() => {
//     if (!canvasRef.current) return;
//     const container = canvasRef.current.parentElement;
//     const w = container?.clientWidth || 800;
//     const h = container?.clientHeight || 500;
//     isDisposed.current = false;

//     import("fabric").then(({ Canvas }) => {
//       if (isDisposed.current) return;

//       const fc = new Canvas(canvasRef.current, {
//         width: w,
//         height: h,
//         backgroundColor: "#fff",
//         isDrawingMode: false,
//         selection: false,
//         interactive: false,
//       });
//       fabricRef.current = fc;

//       const raw = localStorage.getItem(entry.canvasKey);
//       if (raw) {
//         try {
//           fc.loadFromJSON(JSON.parse(raw)).then(() => {
//             if (!isDisposed.current) {
//               fc.forEachObject((o) => {
//                 o.selectable = false;
//                 o.evented = false;
//               });
//               fc.renderAll();
//             }
//           });
//         } catch (e) {
//           console.error("Preview load failed:", e);
//         }
//       }
//     });

//     return () => {
//       isDisposed.current = true;
//       try { fabricRef.current?.dispose(); } catch (_) {}
//       fabricRef.current = null;
//     };
//   }, [entry]);

//   return (
//     <Box
//       sx={{
//         width: "100%",
//         height: "100%",
//         overflow: "hidden",
//         background: "#e8eaed",
//       }}
//     >
//       <canvas ref={canvasRef} style={{ display: "block" }} />
//     </Box>
//   );
// }
